import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import * as krakenModels from '@/model/config/krakenModels';

export type DepositModalActionCallback = Sender<{
  type: 'DEPOSIT_MODAL_STATE_CLOSED' | 'DEPOSIT_MODAL_STATE_OPENED';
  data: object | { payload: object };
}>;

export const watchDepositModalCloseAction = () => {
  return asyncCallback(async (callback: DepositModalActionCallback) => {
    const watcherOptions = {
      callback,
    };

    return await krakenModels.depositCloseWatcher(watcherOptions);
  });
};
export const watchDepositModalOpenAction = () => {
  return asyncCallback(async (callback: DepositModalActionCallback) => {
    const watcherOptions = {
      callback,
    };

    return await krakenModels.depositOpenWatcher(watcherOptions);
  });
};
